import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

import Page from '../../Page';
import CreditsRedeemedTable from './CreditsRedeemedTable';
import GrowthCreditsFormsTable from './GrowthCreditsFormsTable';
import GrowthCreditsStats from './GrowthCreditsStats';
import RedeemCreditsModal from './RedeemCreditsModal';

function GrowthCreditsPage(): JSX.Element {
  const { t } = useTranslation();
  const {
    spacing: { '6': gap },
  } = useMantineTheme();
  const [isRedeemModalOpen, setIsRedeemModalOpen] = useState(false);
  const [statsRefreshKey, setStatsRefreshKey] = useState(0);

  function handleOpenRedeemModal(): void {
    setIsRedeemModalOpen(true);
  }

  function handleCloseRedeemModal(): void {
    setIsRedeemModalOpen(false);
  }

  const handleRedemptionSuccess = useCallback((): void => {
    setStatsRefreshKey((prev) => prev + 1);
  }, []);

  return (
    <Page
      actions={
        <Button onClick={handleOpenRedeemModal} type={'primary'}>
          {t('Redeem Credits')}
        </Button>
      }
      collapseHeader={false}
      description={t(
        'Manage and redeem growth credits to cover marketing costs that help you reach even more donors.',
      )}
      title={t('Growth Credits')}
    >
      <Stack gap={gap}>
        <GrowthCreditsStats refreshKey={statsRefreshKey} />
        <CreditsRedeemedTable />
        <GrowthCreditsFormsTable />
      </Stack>
      <RedeemCreditsModal
        onClose={handleCloseRedeemModal}
        onSuccess={handleRedemptionSuccess}
        opened={isRedeemModalOpen}
      />
    </Page>
  );
}

export default GrowthCreditsPage;
